/**
 *
 * @author: Matthew Rawson @ 29/09/2017 12:13
 * @description:
 * @notes:
 */
import styled from "styled-components"
import {Col} from "react-bootstrap"
import {minWidthMedia} from "@irati/ui/src/global/media"
import padding from "@irati/ui/src/global/padding"

export default styled(Col)`
  padding-left: 0;
  padding-right: 0;

  ${minWidthMedia.tablet`
    padding-left: ${padding.tiny};
    padding-right: ${padding.tiny};
  `}
`
